import { useState } from "react";

import Button from "components/Button";
import HollowButton from "components/HollowButton";

import dispatchChartService from "api/dispatchChartService";
import {
  EParcelDeliveryCategory,
  IDispatchListItem,
  IOutgoingCategory,
} from "dto/Mailroom/IDispatchChart";
import { ENotificationType, notification } from "utils/notification";

import styles from "./outgoing.module.scss";

interface Props {
  parcels: IDispatchListItem[];
  category: IOutgoingCategory;
  onClose: () => void;
  onDone: () => void;
}

const CreateDispatchChartModal = ({
  parcels,
  category,
  onClose,
  onDone,
}: Props) => {
  const { mutate, isLoading } = dispatchChartService.usePrepareDispatchChart();

  // Doręczenie osobiste działa jak przesyłki listowe: tworzymy PRAWDZIWĄ kartę
  // nadawczą (karta doręczenia osobistego „DO") z wydrukiem i potwierdzeniem
  // nadania — domyślnie NIE „nadaj od razu". Tylko odbiór osobisty (wydanie przy
  // okienku) domyślnie oznaczamy jako wysłane od razu (karta fikcyjna).
  const [immediate, setImmediate] = useState(
    category.Category === EParcelDeliveryCategory.PersonalPickup,
  );
  const [date, setDate] = useState<string>(new Date().toLocaleDateString("sv-SE"));

  const kindName = parcels[0]?.DeliveryKindName ?? category.Name;

  const submit = () => {
    mutate(
      {
        ParcelIds: parcels.map((p) => p.Id),
        IsFake: immediate,
        SendDate: immediate ? new Date(date).toISOString() : null,
      },
      {
        onSuccess: () => {
          notification({
            type: ENotificationType.SUCCESS,
            title: immediate ? "Nadano przesyłki" : "Utworzono kartę nadawczą",
            text: immediate
              ? "Przesyłki oznaczono jako wysłane."
              : "Kartę można wydrukować i potwierdzić wysyłkę.",
          });
          onDone();
        },
        onError: () =>
          notification({
            type: ENotificationType.ERROR,
            title: "Błąd",
            text: "Nie udało się utworzyć karty nadawczej.",
          }),
      },
    );
  };

  return (
    <div className={styles.overlay} onMouseDown={onClose}>
      <div className={styles.modal} onMouseDown={(e) => e.stopPropagation()}>
        <div className={styles.modalTitle}>Utwórz kartę nadawczą</div>
        <div className={styles.modalBody}>
          <div className={styles.modalRow}>
            <span>Forma doręczenia:</span>
            <strong>{kindName}</strong>
          </div>
          <div className={styles.modalRow}>
            <span>Liczba przesyłek:</span>
            <strong>{parcels.length}</strong>
          </div>

          <div className={styles.parcelPreview}>
            {parcels.map((p) => (
              <div key={p.Id} className={styles.previewRow}>
                <span className={styles.sig}>{p.ParcelNumber ?? "—"}</span>
                <span>{p.ReceiverName ?? "—"}</span>
              </div>
            ))}
          </div>

          <label className={styles.check}>
            <input
              type="checkbox"
              checked={immediate}
              onChange={(e) => setImmediate(e.target.checked)}
            />
            Nadaj od razu (bez karty pocztowej — oznacz jako wysłane)
          </label>

          {immediate && (
            <div className={styles.field}>
              <label>Data nadania</label>
              <input
                type="date"
                value={date}
                onChange={(e) => setDate(e.target.value)}
              />
            </div>
          )}
        </div>
        <div className={styles.modalFooter}>
          <HollowButton text="Anuluj" onClick={onClose} />
          <Button
            text={immediate ? "Nadaj" : "Utwórz kartę"}
            onClick={submit}
            loading={isLoading}
            disabled={immediate && !date}
          />
        </div>
      </div>
    </div>
  );
};

export default CreateDispatchChartModal;
